export const BASE_PRICES = {
  benchmark: 499,
  competition: 599,
  research: 1250,
};

export const COLORS_LIGHT = {
  red: '#C99C9E',
  blue: '#7396BE',
  green: '#81BE73',
  brown: '#C0A38B',
  grey: '#a2a2a2',
  purple: '#A073BE',
};

export const COLORS = {
  red: '#A55A5E',
  blue: '#175194',
  green: '#2e9417',
  brown: '#A57C5A',
  grey: '#646464',
  purple: '#621794',
  orange: '#F2AC42',
  white: '#ffffff',
  black: '#000000',
};

export const COLORS_WITHOUT_WHITE = {
  red: COLORS.red,
  blue: COLORS.blue,
  green: COLORS.green,
  brown: COLORS.brown,
  grey: COLORS.grey,
  purple: COLORS.purple,
  orange: COLORS.orange,
  black: COLORS.black,
  lightRed: COLORS_LIGHT.red,
  lightBlue: COLORS_LIGHT.blue,
  lightGreen: COLORS_LIGHT.green,
  lightBrown: COLORS_LIGHT.brown,
  lightGrey: COLORS_LIGHT.grey,
  lightPurple: COLORS_LIGHT.purple,
};

export const COLORS_PER_COMMERCIAL_TYPE = {
  tv: COLORS.red,
  radio: COLORS.blue,
  ooh: COLORS.green,
  average: COLORS.grey,
};


export const COLOR_SCHEMES = {
  red: [
    '#84484B',
    '#945154',
    COLORS.red,
    '#AE6A6E',
    '#B77A7E',
    '#C08B8E',
    COLORS_LIGHT.red,
    '#D2ACAE',
    '#DBBDBE',
    '#E4CDCE',
  ],
  blue: [
    '#124076',
    '#144885',
    COLORS.blue,
    '#2E629E',
    '#4573A9',
    '#5C85B4',
    COLORS_LIGHT.blue,
    '#8BA8C9',
    '#A2B9D4',
    '#B9CADE',
  ],
  green: [
    '#247612',
    '#298514',
    COLORS.green,
    '#429E2E',
    '#57A945',
    '#6CB45C',
    COLORS_LIGHT.green,
    '#96C98B',
    '#ABD4A2',
    '#C0DEB9',
  ],
  grey: [
    '#505050',
    '#5a5a5a',
    COLORS.grey,
    '#737373',
    '#838383',
    '#929292',
    COLORS_LIGHT.grey,
    '#b1b1b1',
    '#c1c1c1',
    '#d0d0d0',
  ],
};

export const RESEARCH_STATUS_CLASSES = {
  planned: 'secondary',
  draft: 'secondary',
  submitted: 'info',
  in_progress: 'warning',
  finished: 'success',
  cancelled: 'danger',
  not_active: 'danger',
};

export const RESEARCH_ICON_CLASSES = {
  planned: 'calendar',
  draft: 'pencil',
  submitted: 'list-check',
  in_progress: 'spinner',
  finished: 'check',
  cancelled: 'ban',
  not_active: 'ban',
};

export const GENDER_CHOICES = [
  { key: 'm', value: 'word.male' },
  { key: 'f', value: 'word.female' },
  { key: 'o', value: 'word.other' },
];


export const CHART_COLORS = Object.values(COLORS_WITHOUT_WHITE);
export const CHART_COLORS_5 = [
  COLORS_WITHOUT_WHITE.red,
  COLORS_WITHOUT_WHITE.lightRed,
  COLORS_WITHOUT_WHITE.lightGrey,
  COLORS_WITHOUT_WHITE.lightGreen,
  COLORS_WITHOUT_WHITE.green,
];
